import React from 'react'
import { m } from 'framer-motion'
import { CalendarCheck, MapPin, PhoneCall, Star } from 'lucide-react'
import { useLanguage } from '../../../context/LanguageContext'
import { trackCtaClick } from '../../../utils/analytics'
import {
    PHONE_LINK,
    NAVER_BOOKING_URL,
    NAVER_MAP_URL,
    NAVER_REVIEWS_URL
} from '../../../constants/contact'

const StickyCTA: React.FC = () => {
    const { t } = useLanguage()

    return (
        <aside className="restaurant-sticky-cta" aria-label={t('cta.reserveAria')}>
            <div className="restaurant-sticky-cta-inner">
                <m.a
                    href={PHONE_LINK}
                    whileTap={{ scale: 0.98 }}
                    className="restaurant-sticky-cta-button restaurant-sticky-cta-phone"
                    aria-label={t('cta.phoneAria')}
                    onClick={() => trackCtaClick('call', 'sticky_cta')}
                >
                    <PhoneCall size={18} />
                    <span>{t('cta.phone')}</span>
                </m.a>
                <m.a
                    href={NAVER_BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileTap={{ scale: 0.98 }}
                    className="restaurant-sticky-cta-button restaurant-sticky-cta-primary"
                    aria-label={t('cta.reserveAria')}
                    onClick={() => trackCtaClick('reserve', 'sticky_cta')}
                >
                    <CalendarCheck size={18} />
                    <span>{t('cta.reserve')}</span>
                </m.a>
                <m.a
                    href={NAVER_MAP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileTap={{ scale: 0.98 }}
                    className="restaurant-sticky-cta-button restaurant-sticky-cta-secondary"
                    aria-label={t('cta.directionsAria')}
                    onClick={() => trackCtaClick('map', 'sticky_cta')}
                >
                    <MapPin size={18} />
                    <span>{t('cta.directions')}</span>
                </m.a>
                <m.a
                    href={NAVER_REVIEWS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileTap={{ scale: 0.98 }}
                    className="restaurant-sticky-cta-button restaurant-sticky-cta-review"
                    aria-label={t('cta.reviewsAria')}
                    onClick={() => trackCtaClick('reviews', 'sticky_cta')}
                >
                    <Star size={18} />
                    <span>{t('cta.reviews')}</span>
                </m.a>
            </div>
        </aside>
    )
}

export default StickyCTA
